import { Use } from '../interfaces/prop.interface';

export const usesJson: Use[] = [
    {
        id: "0",
        name: "Todos"
    },
    {
        id: "1",
        name: "Almacén"
    },
    {
        id: "2",
        name: "Edificio"
    },
    {
        id: "5",
        name: "Local comercial"
    },
    {
        id: "6",
        name: "Nave industrial"
    },
    {
        id: "7",
        name: "Oficina"
    }
    ,
    {
        id: "8",
        name: "Parking"
    },
    // {
    //     id: "11",
    //     name: "Terciario"
    // },
    {
        id: "13",
        name: "Vivienda"
    }
]

export const strategiesJson: any[] = [
    {
        id: "1",
        name: "Venta"
    },
    {
        id: "2",
        name: "Alquiler"
    },
    {
        id: "3",
        name: "Venta y Alquiler"
    }
]